<!--TODO: Philipp/Alex title switch-->
<sim-basic-material-dialog
	(closeClicked)="close({action: 'ok', followUpAction: 'dashboard'})"
	[finished]="finished"
	[headerIcon]="getHeaderIcon()"
	[headerText]="getDialogTitle()"
	[matDialogData]="data"
	[rect]="rect"
	[showClosingX]="false"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		@if (state !== "StopRecordingFailed" && scenarioRecordings) {
			<div class="progressContainer">
				@if (recordingFinishedDialogViewState === "NoScheduledRunsOrSessions") {
					<mat-accordion>
						@for (scenarioRecording of scenarioRecordings; track scenarioRecording; let scenarioRecordingIndex = $index) {
							<mat-expansion-panel [disabled]="disableResultExpansion">
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="scenarioRecordingDisplayName">
											{{ scenarioRecording.displayName }}
										</div>
										<div class="scenario">
											{{
												T.PRO_RECORDING_DIALOG_SCENARIO_LABEL
													| translate
														: {
																name: scenarioRecording?.scenario?.name ?? "",
														  }
											}}
										</div>
									</mat-panel-title>
									<mat-panel-description>
										<mat-progress-bar
											[value]="scenarioRecording['DownloadProgress'] ?? 0"
											class="w-100"
											color="accent"
											mode="determinate"
										/>
										@if (scenarioRecording["DownloadProgress"] !== 100) {
											<div class="loadingText">
												{{ T.PRO_RECORDING_DIALOG_PROCESSING_RECORDING | translate }}
											</div>
										}
									</mat-panel-description>
								</mat-expansion-panel-header>
								@for (scenarioRecordingScene of scenarioRecording.recordingScenes; track scenarioRecordingScene) {
									<div class="w-100">
										<table
											[dataSource]="scenarioRecordingScene.videoFiles"
											[trackBy]="TrackByMethods.trackByVideoFile"
											class="w-100"
											mat-table
										>
											<ng-container matColumnDef="fileName">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_NAME | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.videoFiles" mat-cell>
													{{ element.fileName }}
												</td>
											</ng-container>
											<ng-container matColumnDef="fileSize">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_SIZE | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.videoFiles" mat-cell>
													{{ element.fileSize | fileSize: "MB" : 2 }}
												</td>
											</ng-container>
											<ng-container matColumnDef="downloaded">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_DOWNLOAD | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.videoFiles" mat-cell>
													<span>
														@if (element.isValid && element.downloaded) {
															<mat-icon fontIcon="fa-check" fontSet="fas" />
														}
														@if (element.isValid && !element.downloaded) {
															<mat-icon class="fa-spin" fontIcon="fa-spinner-third" fontSet="fas" inline />
														}
														@if (!element.isValid) {
															<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" />
														}
													</span>
												</td>
											</ng-container>
											<ng-container matColumnDef="posterCreated">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_POSTER | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.videoFiles" mat-cell>
													<span>
														@if (element.isValid && (element.posterCreated || isFinished)) {
															<mat-icon fontIcon="fa-check" fontSet="fas" />
														}
														@if (element.isValid && !element.posterCreated && !isFinished) {
															<mat-icon class="fa-spin" fontIcon="fa-spinner-third" fontSet="fas" inline />
														}
														@if (!element.isValid) {
															<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" />
														}
													</span>
												</td>
											</ng-container>
											<ng-container matColumnDef="lengthAdapted">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_LENGTH_ADAPTED | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.videoFiles" mat-cell>
													<span>
														@if (element.isValid && (element.lengthAdapted || isFinished)) {
															<mat-icon fontIcon="fa-check" fontSet="fas" />
														}
														@if (element.isValid && !element.lengthAdapted && !isFinished) {
															<mat-icon class="fa-spin" fontIcon="fa-spinner-third" fontSet="fas" inline />
														}
														@if (!element.isValid) {
															<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" />
														}
													</span>
												</td>
											</ng-container>
											<tr
												*matHeaderRowDef="['fileName', 'fileSize', 'downloaded', 'posterCreated', 'lengthAdapted']"
												mat-header-row
											></tr>
											<tr
												*matRowDef="
													let row;
													columns: ['fileName', 'fileSize', 'downloaded', 'posterCreated', 'lengthAdapted']
												"
												mat-row
											></tr>
										</table>
										<table
											[dataSource]="scenarioRecordingScene.audioFiles"
											[trackBy]="TrackByMethods.trackByAudioFile"
											class="w-100"
											mat-table
										>
											<ng-container matColumnDef="name">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_NAME | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.audioFiles" mat-cell>
													{{ element.name }}
												</td>
											</ng-container>
											<ng-container matColumnDef="duration">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_DURATION | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.audioFiles" mat-cell>
													{{ element.duration }}
												</td>
											</ng-container>
											<ng-container matColumnDef="downloaded">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_DOWNLOAD | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.audioFiles" mat-cell>
													@if (element.downloaded) {
														<mat-icon fontIcon="fa-check" fontSet="fas" />
													}
													@if (!element.downloaded) {
														<mat-icon class="fa-spin" fontIcon="fa-spinner-third" fontSet="fas" inline />
													}
												</td>
											</ng-container>
											<ng-container matColumnDef="converted">
												<th *matHeaderCellDef mat-header-cell>
													{{ T.PRO_RECORDING_DIALOG_CONVERTED | translate }}
												</th>
												<td *appMatCellDef="let element; dataSource: scenarioRecordingScene.audioFiles" mat-cell>
													@if (element.converted) {
														<mat-icon fontIcon="fa-check" fontSet="fas" />
													}
													@if (element.converted) {
														<mat-icon class="fa-spin" fontIcon="fa-spinner-third" fontSet="fas" inline />
													}
												</td>
											</ng-container>
											<tr *matHeaderRowDef="['name', 'duration', 'downloaded', 'converted']" mat-header-row></tr>
											<tr *matRowDef="let row; columns: ['name', 'duration', 'downloaded', 'converted']" mat-row></tr>
										</table>
									</div>
								}
							</mat-expansion-panel>
						}
					</mat-accordion>
				}
				@switch (recordingFinishedDialogViewState) {
					@case ("ScheduledRunsAvailable") {
						<div class="mat-h2 nextScheduledRunContainerTitle">
							{{ T.RECORDING_FINISHED_DIALOG_NEXT_SCHEDULED_RUN_WITH_COLON | translate }}
						</div>
						<div
							*ngVar="
								nextScenarioRecordingGroup.scenarioRecordingsMap[0].scenarioId | getScenarioById | async as nextScenario
							"
							class="nextScheduledRunContainer"
						>
							<ng-container>
								<div class="upperDescriptiveNextRun">
									<div class="estimatedTimeDesc">{{ T.PRO_RECORDING_FINISHED_ESTIMATED_TIME_LABEL | translate }}</div>
									<div class="scenarioDesc">{{ T.PRO_RECORDING_FINISHED_DIALOG_SCENARIO_LABEL | translate }}</div>
									<div class="actionDesc">{{ T.PRO_RECORDING_FINISHED_DIALOG_ACTION_LABEL | translate }}</div>
								</div>
								<div class="underDescriptiveNextRunValues">
									<div class="estimatedTimeVal">
										@if (nextScenarioRecordingGroup.plannedStart && nextScenarioRecordingGroup.plannedEnd) {
											{{ nextScenarioRecordingGroup.plannedStart | date: (T.DATE_FORMAT_TIME | translate) :'': translateService.currentLang }}
											-
											{{ nextScenarioRecordingGroup.plannedEnd | date: (T.DATE_FORMAT_TIME | translate) :'': translateService.currentLang }}
										}
										@if (!nextScenarioRecordingGroup.plannedStart && !nextScenarioRecordingGroup.plannedEnd) {
											{{ T.SHARED_EVENT_SESSION_NOT_SET | translate }}
										}
									</div>
									<div class="scenarioVal dottedField">
										<a (click)="openScenarioInfoCon(nextScenario)" class="clickable">{{
											nextScenario ? nextScenario?.name : (T.GLOBAL_TXT_LOADING_WITH_DOTS | translate)
										}}</a>
										<button (click)="openChangeScenarioForNextRunDialog(nextScenario)" color="accent" mat-icon-button>
											<mat-icon fontIcon="fa-pen" fontSet="fad" />
										</button>
									</div>
									<div class="actionVal">
										<button
											(click)="continueTrainingSession()"
											[disabled]="stopRecordingFinished === false"
											color="accent"
											mat-raised-button
										>
											{{ T.PRO_RECORDING_FINISHED_DIALOG_START_SCENARIO_BTN | translate }}
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					}
					@case ("ScheduledSessionsAvailable") {
						<div class="mat-h2 nextScheduledRunContainerTitle">
							{{ T.PRO_RECORDING_FINISHED_DIALOG_NEXT_SCHEDULED_SESSION | translate }}
						</div>
						@if (nextSession) {
							<sim-session-card
								[event]="data.event"
								[sessionStartable]="false"
								[session]="nextSession"
								[showJoinStartActions]="false"
							/>
						}
					}
				}
			</div>
		}

		@if (state === "StopRecordingFailed") {
			<div>
				<h3 class="mat-h3">
					{{ T.RECORDER_TXT_STOP_RECORDING_ERROR | translate }}
				</h3>
			</div>
			<div>
				<h3 class="mat-h3">{{ errorMessage }}</h3>
			</div>
		}
	</ng-container>

	<ng-container actions>
		@switch (recordingFinishedDialogViewState) {
			@case ("NoScheduledRunsOrSessions") {
				<button (click)="navigateToDashboard()" [disabled]="!allRecordingsStopped" color="accent" mat-button>
					<mat-icon fontIcon="fa-home" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.PRO_RECORDING_DIALOG_BUTTON_HOME | translate }}
					@if (allRecordingsStopped) {
						<sim-countdown-timer (onTimeUp)="navigateToDashboard()" [seconds]="60" />
					}
				</button>
				@if (hasLicenseModule(Modules.EventDesigner)) {
					<button (click)="createNewTrainingSession()" color="accent" mat-button style="margin-right: auto">
						<mat-icon fontIcon="fa-file-plus" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
						{{ T.PRO_RECORDING_DIALOG_BUTTON_NEW_SESSION | translate }}
					</button>
				}
				@if (!hasLicenseModule(Modules.EventDesigner)) {
					<button (click)="openInArchive()" [disabled]="!isFinished" color="accent" mat-button style="margin-right: auto">
						<mat-icon fontIcon="fa-archive" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
						{{ T.PRO_RECORDING_DIALOG_BUTTON_OPEN_ARCHIVE | translate }}
					</button>
				}
				<sim-button
					(onClick)="continueTrainingSession()"
					[disabled]="stopRecordingFinished === false"
					[icon]="{fontSet: 'fa', fontIcon: 'fa-plus'}"
					color="accent"
					style="margin-right: 15px"
					[label]="T.PRO_RECORDING_DIALOG_BUTTON_ADD_SCENARIO"
				/>
				@if (!hasLicenseModule(Modules.EventDesigner)) {
					<sim-button
						(onClick)="createNewTrainingSession()"
						[icon]="{fontSet: 'fad', fontIcon: 'fa-file-plus'}"
						color="accent"
						style="margin-right: 15px"
						[label]="T.PRO_RECORDING_DIALOG_BUTTON_NEW_SESSION"
					/>
				}
			}
			@case ("ScheduledRunsAvailable") {
				<button (click)="navigateToDashboard()" color="accent" mat-button>
					<mat-icon fontIcon="fa-home" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.PRO_RECORDING_DIALOG_BUTTON_HOME | translate }}
				</button>
				<button (click)="openSessionInEventDashboard()" color="accent" mat-button style="margin-right: auto">
					<mat-icon fontIcon="fa-calendar-week" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.PRO_RECORDING_DIALOG_BUTTON_DASHBOARD | translate }}
				</button>
			}
			@case ("ScheduledSessionsAvailable") {
				<button (click)="navigateToDashboard()" color="accent" mat-button>
					<mat-icon fontIcon="fa-home" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.PRO_RECORDING_DIALOG_BUTTON_HOME | translate }}
				</button>
				<button (click)="continueTrainingSession()" color="accent" mat-button style="margin-right: auto">
					<mat-icon fontIcon="fa-plus" fontSet="fa" inline style="font-size: 1.4em; margin-right: 10px" />
					{{ T.PRO_RECORDING_DIALOG_BUTTON_ADD_SCENARIO_TO_FINISHED_SESSION | translate }}
				</button>
				<sim-button
					(onClick)="openSessionInEventDashboard()"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-calendar-week'}"
					color="accent"
					[label]="T.PRO_RECORDING_DIALOG_BUTTON_DASHBOARD"
				/>
			}
		}
	</ng-container>
</sim-basic-material-dialog>
